module.exports = __webpack_public_path__ + "media/images/services/apiary-e7c7437b8f9d370562603f045d7f172e.jpg";